import { ModalSize } from '../../services/modal/mvd-modal.enum';
import { MvdModalService } from '../../services/modal/mvd-modal.service';

export class SharedConfirmData {
    public dTitle = 'Confirm';
    public dMessage: string = undefined;
    public dOkBtnText: string = undefined;
    public dCancelBtnText: string = undefined;
    public dOkBtnFunc: () => void = undefined;
    public isXButtonEnabled = true;

    constructor(protected caller: MvdModalService = undefined) {}

    body(message) {
        this.dMessage = message;
        return this;
    }

    cancelBtn(cancelBtnText) {
        this.dCancelBtnText = cancelBtnText;
        return this;
    }

    okBtn(okBtnText) {
        this.dOkBtnText = okBtnText;
        return this;
    }

    okBtnFunc(okBtnFunc: () => void) {
        this.dOkBtnFunc = okBtnFunc;
        return this;
    }

    // open modal to size (optional)
    open(size?: ModalSize) {
        return this.caller.confirmModal(this, size);
    }

    title(title) {
        this.dTitle = title;
        return this;
    }

    disableXButton() {
        this.isXButtonEnabled = false;
        return this;
    }
}
